"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountPlanSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
const account_plan_terms_1 = require("./account-plan-terms");
const account_plan_details_1 = require("./account-plan-details");
const plan_1 = require("./plan");
exports.AccountPlanSchema = zod_1.z.object({
  account_id: zod_1.z.string().uuid(),
  tenant: zod_1.z.nativeEnum(lingo2_models_1.TenantEnum),
  plan_id: zod_1.z.string().uuid(),
  plan_terms: account_plan_terms_1.AccountPlanTerms20240118PackageSchema.or(zod_1.z.object({})).or(zod_1.z.null()).default({}).optional(),
  next_plan_id: zod_1.z.string().uuid().or(zod_1.z.null()).optional(),
  expires_at: zod_1.z.string().datetime().or(zod_1.z.date()),
  subscription_status: zod_1.z.nativeEnum(lingo2_models_1.BillingSubscriptionStatusEnum),
  details: account_plan_details_1.AccountPlanDetailsSchema.partial().default({}),
  is_trial_use: zod_1.z.boolean().default(false),
  reason_for_deactivation: zod_1.z.nativeEnum(lingo2_models_1.ReasonForPlanDeactivationEnum).or(zod_1.z.null()),
  created_at: zod_1.z.string().datetime().or(zod_1.z.date()).or(zod_1.z.null()).optional(),
  updated_at: zod_1.z.string().datetime().or(zod_1.z.date()).or(zod_1.z.null()).optional(),
  plan: plan_1.PlanSchema.optional()
});
